import $foreign from "./foreign.cjs";
var notNull = $foreign.notNull;
var $$null = $foreign.null;
var nullable = $foreign.nullable;
export { notNull, $$null as null, nullable };
